export default __webpack_public_path__ + "static/media/my-glasses.2a970254.png";